import { Define } from '../../../core/decorators';
import { TAG_TERTIARY } from '../../../core/utils/constants/tags';
import { ButtonVariation } from '../button';
import { HTMLBnumButton } from '../button/bnum-button';
import { Variation } from '../button/bnum-button.internal/decorators';

/**
 * Bouton Bnum de type "Secondary".
 *
 * @todo Faire la documentation
 * 
 * @category Buttons
 */
@Define({ tag: TAG_TERTIARY })
@Variation(ButtonVariation.TERTIARY)
export class HTMLBnumTertiaryButton extends HTMLBnumButton {
	constructor() {
		super();
	}
}
